import { get } from "lodash";
import { useEffect, useState } from "react";
import { theme } from "../../../../tailwind.config";

type ViewportSettings = {
    width?: number;
    isMobileView?: boolean;
};

export const checkIfMobileView = () =>
    window.innerWidth <=
    Number(get(theme, "screens.md", "768px").toString().replaceAll("px", ""));

const useViewport = (): ViewportSettings => {
    const [viewportSettings, setViewportSettings] =
        useState<ViewportSettings | null>({
            width: window.innerWidth,
            isMobileView: checkIfMobileView(),
        });

    useEffect(() => {
        const newViewportSettings: ViewportSettings = {
            width: window.innerWidth,
            isMobileView: checkIfMobileView(),
        };

        const handleWindowResize = () =>
            setViewportSettings(newViewportSettings);

        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    return { ...viewportSettings };
};

export default useViewport;
